import axios from '@/utils/axios';

// 获取banner列表
export const getConsumerMenuList = params => axios.get('/website/menu/getConsumerMenuList', { params });

// 获取banner列表
export const clickBanner = params => axios.post('/website/banner/clickBanner', params);

// 获取banner列表
export const getConsumerList = params => axios.get('/website/banner/getConsumerList', { params });

// 获取依联网介绍
export const getModule8 = params => axios.get('/website/indexModule/getModule8', { params });

// 获取公司介绍
export const getModule1 = params => axios.get('/website/indexModule/getModule1', { params });

// 获取服装数字化定制平台
export const getModule2 = params => axios.get('/website/indexModule/getModule2', { params });

// 获取洗护数字化定制平台
export const getModule3 = params => axios.get('/website/indexModule/getModule3', { params });

// 获取绿洲数字众播基地
export const getModule4 = params => axios.get('/website/indexModule/getModule4', { params });

// 获取衣联硬件
export const getModule5 = params => axios.get('/website/indexModule/getModule5', { params });

// 获取合作伙伴
export const getModule6 = params => axios.get('/website/indexModule/getModule6', { params });

// 获取底栏配置
export const getModule7 = params => axios.get('/website/indexModule/getModule7', { params });

// 获取新闻列表
export const getNewsList = params => axios.get('/website/content/getConsumerList', { params });

// 获取新闻详情
export const getNewsDetail = params => axios.get('/website/content/getConsumerContent', { params });